export default __webpack_public_path__ + "static/media/vendorDefault.963cd072.png";